import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchGrammarTopicById } from "./grammarService";
import "./GrammarTopicDetailPage.css";

const BASE_ROOT = process.env.REACT_APP_BASE_URL_ROOT || "";
const toPublicUrl = (url) => url?.replace(/\/api\/media-images\//, "/api/public/media-images/") ?? url;
const toImgSrc = (url) => !url ? "" : toPublicUrl(url.startsWith("http") ? url : `${BASE_ROOT}${url}`);

const GrammarTopicDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [topic, setTopic] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const res = await fetchGrammarTopicById(id);
      if (res.status === 200 && res.data?.status) setTopic(res.data.data);
      setLoading(false);
    };
    load();
  }, [id]);

  if (loading) return (
    <div className="gtd-shell">
      <Navbar />
      <div className="gtd-page">
        <div className="gtd-state"><span className="gtd-spinner" /><p>Loading…</p></div>
      </div>
      <Footer />
    </div>
  );

  if (!topic) return (
    <div className="gtd-shell">
      <Navbar />
      <div className="gtd-page">
        <div className="gtd-state">
          <span style={{ fontSize: "2.5rem" }}>📭</span>
          <p>Topic not found.</p>
          <button className="gtd-back-btn" onClick={() => navigate("/study/grammar")}>← Back to Grammar</button>
        </div>
      </div>
      <Footer />
    </div>
  );

  return (
    <div className="gtd-shell">
      <Navbar />
      <div className="gtd-page">

        <button className="gtd-back-btn" onClick={() => navigate("/study/grammar")}>
          ← Back to Grammar
        </button>

        {/* Hero */}
        <div className="gtd-hero">
          {topic.coverImageUrl ? (
            <img src={toImgSrc(topic.coverImageUrl)} alt={topic.title} className="gtd-hero-img" />
          ) : (
            <div className="gtd-hero-placeholder">
              <span className="gtd-hero-icon">{topic.icon || "📘"}</span>
            </div>
          )}
          <div className="gtd-hero-overlay">
            <span className="gtd-hero-tag">Grammar</span>
            <h1 className="gtd-hero-title">{topic.title}</h1>
            {topic.description && <p className="gtd-hero-desc">{topic.description}</p>}
            <span className="gtd-hero-badge">{topic.subTopics?.length || 0} sub-topics</span>
          </div>
        </div>

        {/* Sub-topic list */}
        {(!topic.subTopics || topic.subTopics.length === 0) ? (
          <div className="gtd-state">
            <span style={{ fontSize: "2rem" }}>📂</span>
            <p>No sub-topics available yet.</p>
          </div>
        ) : (
          <>
            <h2 className="gtd-list-heading">Sub-Topics</h2>
            <div className="gtd-list">
              {topic.subTopics.map((st, idx) => (
                <div
                  key={st.id}
                  className="gtd-item"
                  onClick={() => navigate(`/study/grammar/sub-topic/${st.id}`, { state: { backUrl: `/study/grammar/${topic.id}` } })}
                >
                  <div className="gtd-item-num">{idx + 1}</div>
                  <div className="gtd-item-info">
                    <h3 className="gtd-item-title">{st.title}</h3>

                  </div>
                  <span className="gtd-item-arrow">→</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default GrammarTopicDetailPage;
